import { feedbackFormLink } from '@/types/constants';
import { Link } from 'react-router-dom';

interface ProfileFooterProps {
    username?: string
}
const ProfileFooter = ({ username }: ProfileFooterProps) => {
    const content = username ? (
        <>
            Join <span className="font-semibold mx-1">{username}</span> on
            <span className="font-semibold ml-1">allmygigs</span>.
        </>
    ) : (
        <>
            Powered by <span className="font-semibold ml-1">allmygigs</span>.
        </>
    );

    return (
        <footer className="w-full py-6 mt-auto flex flex-col items-center gap-2">
            <Link
                to="/"
                className="inline-flex items-center font-medium bg-gradient-to-r from-purple-300 to-purple-100 bg-clip-text text-transparent hover:from-purple-700 hover:to-purple-900 transition-all duration-200 hover:-translate-y-[0.5px]"
            >
                {content}
            </Link>
            <a
                href={feedbackFormLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-s text-gray-400 hover:text-gray-300 transition-colors duration-200"
            >
                Have feedback?
            </a>
        </footer>
    );
};
export default ProfileFooter;